import { create } from 'zustand'

type Store = {
  focusId: string | null
  setFocus: (id: string | null) => void
  clearFocus: (id?: string | null) => void
  fromURL: (search: string | undefined | null) => void
  highlightIds: string[]
  setHighlights: (ids: (string|number)[]) => void
  clearHighlights: () => void
  removeHighlight: (id: string | number) => void
}

export const useFocusStore = create<Store>((set, get) => ({
  focusId: null,
  highlightIds: [],
  setFocus: (id) => set({ focusId: id ? String(id) : null }),
  clearFocus: (id) => {
    const cur = get().focusId
    if (!id || String(id) === String(cur)) {
      set({ focusId: null })
    }
  },
  setHighlights: (ids) => set({ highlightIds: Array.from(new Set((ids||[]).map(String))) }),
  clearHighlights: () => set({ highlightIds: [] }),
  removeHighlight: (id) => {
    const target = String(id)
    const next = (get().highlightIds || []).filter(x => String(x) !== target)
    set({ highlightIds: next })
  },
  fromURL: (search) => {
    try {
      const s = String(search || '')
      const params = new URLSearchParams(s.startsWith('?') ? s : `?${s}`)
      const f = params.get('focus') || params.get('opp')
      if (f) set({ focusId: String(f) })
      const many = params.get('focus_many')
      if (many) {
        const ids = many.split(',').map(v=> v.trim()).filter(Boolean)
        if (ids.length) set({ highlightIds: Array.from(new Set(ids)) })
      }
    } catch {
      /* noop */
    }
  },
}))
